import { useCallback, useEffect, useRef, useState } from 'react'
import { useDI } from '@/di/DIContext'

type CopyStatus = 'idle' | 'copied' | 'error'

export function useCopyLink() {
  const { clipboardService } = useDI()
  const [status, setStatus] = useState<CopyStatus>('idle')
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }
  }, [])

  const resetStatusAfterDelay = (delay: number) => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }
    timerRef.current = setTimeout(() => {
      setStatus('idle')
      timerRef.current = null
    }, delay)
  }

  const copyLink = useCallback(
    async (url: string) => {
      try {
        await clipboardService.writeText(url)
        setStatus('copied')
        resetStatusAfterDelay(2000)
      } catch (err) {
        console.error('Failed to copy:', err)
        setStatus('error')
        resetStatusAfterDelay(2000)
      }
    },
    [clipboardService],
  )

  return {
    copyLink,
    copied: status === 'copied',
    error: status === 'error',
  }
}
